import { apiSlice } from "../../app/api/apiSlice"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const SensorsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        startMonitoring: builder.mutation({
            query: (id) => ({
                url: `/sensors/Blackline/StartMonitoring/${id}`,
                method: 'POST',
            })
        }),

        stopMonitoring: builder.mutation({
            query: (id) => ({
                url: `/sensors/Blackline/StopMonitoring/${id}`,
                method: 'POST',
            })
        }),
    })
})

export const {
    useStartMonitoringMutation,
    useStopMonitoringMutation
} = SensorsSlice  